import { Helper } from 'casbin';
import gql from 'graphql-tag';
export class ApolloAdapter {
    constructor(apolloClient, userId, tenantId) {
        this.client = apolloClient;
        this._userId = userId;
        this._tenantId = tenantId;
    }
    set client(client) {
        this._client = client;
    }
    get client() {
        return this._client;
    }
    async loadPolicy(model) {
        return this.loadFilteredPolicy(model, {
            user: this._userId,
            tenant: this._tenantId,
        });
    }
    async loadFilteredPolicy(model, filter) {
        if (!filter.tenant || !filter.user) {
            return;
        }
        const allLines = await this.getFilteredPolicy(filter);
        allLines.forEach((rule) => this.loadPolicyLine(rule, model));
    }
    async getFilteredPolicy(filter) {
        if (!filter.tenant || !filter.user) {
            throw new Error('Missing required filters: tenant, user');
        }
        const apolloQueryResult = await this.client.query({
            query: gql `
        query {
          casbinRules(
            userId: "${filter.user}",
          ) {
                ptype,
                v0,
                v1,
                v2,
                v3,
                v4,
                v5,
            }
        }
      `,
            fetchPolicy: 'network-only',
        });
        const { errors, data } = apolloQueryResult;
        if (errors) {
            throw new Error('Something went wrong.');
        }
        return data.casbinRules;
    }
    isFiltered() {
        return true;
    }
    loadPolicyLine(line, model) {
        const policy = [line.ptype, line.v0, line.v1, line.v2, line.v3, line.v4, line.v5].filter((n) => n).join(', ');
        Helper.loadPolicyLine(policy, model);
    }
}
//# sourceMappingURL=adapter.js.map